import { SegObjectPropertyMap } from 'src/app/state/case/case.state'

export enum PipelineType {
    Cubing = 'CUB',
    Segmentation = 'SEG',
    NucleusExpansion = 'EXP',
    // todo: the registration type exists for backwards compatibility and can probably be removed later on
    Registration = 'REG',
    mIHC = 'MIH',
    cycIF = 'CYC',
    MapIntensity = 'INT',
    RecurrentNeighborhoods = 'RCN',
    NeighborhoodEnrichment = 'NEN',
    AutoCellDetection = 'ACD',
    Clustering = 'CLU',
    tsneClustering = 'TSN',
    umapClustering = 'UMA',
    Plotting = 'PLT',
}

export interface SegmentationParameters {
    type: PipelineType.Segmentation
    target: string | undefined
    nucleus: string | undefined
    model: string
    batch: boolean
}

export interface NucleusExpansionParameters {
    type: PipelineType.NucleusExpansion
    target: string | undefined
    batch: boolean
}

export interface RegistrationParameters {
    type: PipelineType.mIHC | PipelineType.cycIF
    target: string | undefined
    source: (string | undefined)[]
    batch: boolean
}

export interface IntensityParameters {
    type: PipelineType.MapIntensity
    target: string | undefined
    mask: string | undefined
    batch: boolean
    segSource?: SegObjectPropertyMap | undefined
    radius?: number
    summary?: string
}

export interface RecurrentNeighborhoodsParameters {
    // TODO [ARIADNE-292]: reuse RecurrentNeighborhoodsResult details here?
    type: PipelineType.RecurrentNeighborhoods
    selections: ({ name: string; type: number } | undefined)[]
    experimentName: string
    keepBackground: boolean
    radius: number
    numberOfRcn: number
    batch: boolean
}
export interface NeighborhoodEnrichmentParameters {
    type: PipelineType.NeighborhoodEnrichment
    selections: ({ name: string; type: number } | undefined)[]
    experimentName: string
    keepBackground: boolean
    radius: number
    batch: boolean
}

export interface AutoCellDetectionParameters {
    type: PipelineType.AutoCellDetection
    organism: string | undefined
    markerName: (string | undefined)[]
    transcriptName: (string | undefined)[]
    batch: boolean
}

export interface TsneParameters {
    type: PipelineType.tsneClustering
    markers: string[]
    perplexity: number
    numberOfIterations: number
    normalization: ClusteringNormalization
}

export interface UmapParameters {
    type: PipelineType.umapClustering
    markers: string[]
    numberOfNeighbors: number
    minimumDistance: number
    spread: number
    normalization: ClusteringNormalization
}

export interface PlottingParameters {
    type: PipelineType.Plotting
    plotType: string
    name: string
    groups: any[][]
    cohorts: { id: number; name: string }[]
    properties: string[]
    details: any[]
    segSource: string
}

export interface PlottingParameters {
    type: PipelineType.Plotting
    plotType: string
    name: string
    groups: any[][]
    cohorts: { id: number; name: string }[]
    properties: string[]
    details: any[]
    segSource: string
}

export type ClusteringParametersWithName = { name: string } & (UmapParameters | TsneParameters)

export enum SegmentationType {
    Cell = 'cell',
    Tissue = 'tissue',
    Artifacts = 'artifacts',
    Plaque = 'plaque',
    Pathology = 'pathology',
}

export enum AutoCellDetectionType {
    Human = 'human',
    Mouse = 'mouse',
}

export enum JobStatus {
    Rejected = 'Rejected',
    Closed = 'Closed',
    // all other status values are mapped to the yellow icon, such as New, Resolved, Feedback, ...
    // there are many more status values possible, but do not have to be integrated currently
}

export enum ClusteringNormalization {
    PerFeature = 'Per Feature',
    None = 'None',
    Global = 'Global',
}

export enum UmapDistanceMetric {
    Euclidean = 'Euclidean',
    Correlation = 'Correlation',
}

export interface Job {
    id: number
    name: string
    type: PipelineType
    status: JobStatus
    startDate: string
    estimatedHours: number | null
    progress: number
    dataset?: string
}
